import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { GeocodingSettingsComponent } from './settings-geocoding.component';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';

export function provideSettingsElementGeocoding(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'geocoding',
        name: 'Geoservices',
        icon: 'pi pi-map',
        component: GeocodingSettingsComponent,
        order: 8,
        translateName: 'SETTINGS_GEOCODING.GEOSERVICES.TITLE',
        resource_key: 'geocodingSettings',
        required_action: 'read',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'workspace',
          name: 'Workspace',
          order: 1,
          translateName: 'SETTINGS.CATEGORIES.WORKSPACE',
        },
      },
      multi: true,
    },
  ]);
}
